// Часы поста против числа охранников: больше, чем есть в сутках, не отстоять.
//
// Часы в сутки у поста — это часы ВСЕХ его охранников вместе: сервер складывает их по постам
// как есть и на число охранников не умножает (server/app/domain/norms.py,
// norm_hours_from_posts). Значит на каждого одновременно стоящего приходится не больше 24
// часов. Аудит 23.09.2026 на копии боевой базы нашёл у ПетроАльянса пост «1 охранник
// одновременно · 36 часов»: один человек тридцать шесть часов в сутки не простоит, а из часов
// постов складывается норматив объекта и дальше недобор в часах — ошибка уходила в цифры
// молча, и ни один экран о ней не говорил.
//
// Это ПРЕДУПРЕЖДЕНИЕ, а не запрет: у заказчика бывают посты, где часы — это часы нескольких
// охранников вместе, а число одновременно стоящих записано иначе. Решает он, а не программа.

import { diffHours, formatHours, hoursWord } from '@/shared/hours/format';
import { countLabel } from '@/shared/text/plural';

/** В сутках 24 часа: больше один охранник на посту не простоит. */
const ЧАСОВ_В_СУТКАХ = 24;

/** «при 2 охранниках», «при 21 охраннике»: предложный падеж после числа. */
const ПРИ_ОХРАННИКАХ = ['охраннике', 'охранниках', 'охранниках'] as const;

/**
 * Что не так с часами поста — словами и с тем, что сделать. `null` — всё сходится, либо
 * введённое ещё не число: об этом скажет проверка при сохранении, дважды говорить незачем.
 *
 * Часы принимаются и с запятой: в панели правки их проверяют прямо по мере ввода.
 */
export function лишниеЧасыПоста(часы: string, охранников: number): string | null {
  if (!Number.isInteger(охранников) || охранников < 1) {
    return null;
  }
  const запись = часы.trim().replace(',', '.');
  const предел = String(ЧАСОВ_В_СУТКАХ * охранников);

  let превышение: string;
  try {
    // Разность десятичная и точная, как всё с часами в проекте: «24.00» при одном охраннике
    // не превышение, а ровно сутки. В число переводится уже готовая разность, и только ради
    // её знака — его перевод не искажает.
    превышение = diffHours(запись, предел);
  } catch {
    return null;
  }
  if (!(Number(превышение) > 0)) {
    return null;
  }

  const сколько = `${formatHours(запись)} ${hoursWord(запись)} в сутки`;
  const чтоСделать = 'Проверьте часы поста или число охранников.';
  if (охранников === 1) {
    return `${сколько} при одном охраннике, а в сутках всего 24 часа. ${чтоСделать}`;
  }
  return `${сколько} при ${countLabel(охранников, ПРИ_ОХРАННИКАХ)}, а вместе они отстоят за сутки самое большее ${formatHours(предел)} ${hoursWord(предел)}. ${чтоСделать}`;
}
